import React from 'react'
import { connect } from 'react-redux'
import Loading from './widgets/Loading'
import agent from '../agent'
import { store } from '../store'
import { push } from 'react-router-redux'

import {
    DIRECTORY_ADD_PAGE_LOADED,
    DIRECTORY_ADD_PAGE_UNLOADED,
    DIRECTORY_ADD,
} from '../constants/actionTypes'
import Nav from './widgets/Nav'
import Header from './widgets/Header'

import { Link } from 'react-router-dom'
import Util from '../util/util'
import ListErrors from './widgets/ListErrors'
import { Translation } from 'react-i18next'
import i18n from '../languages/lang.js'

const Promise = global.Promise

const mapStateToProps = state => ({
    ...state.file,
    currentUser: state.common.currentUser,
    inProgress: state.common.inProgress,
})

const mapDispatchToProps = dispatch => ({
    onLoad: (payload) =>
        dispatch({ type: DIRECTORY_ADD_PAGE_LOADED, payload }),
    onSubmit: (payload, directory) => {
        dispatch({ type: DIRECTORY_ADD, payload, directory })
    },
    onUnload: () =>
        dispatch({ type: DIRECTORY_ADD_PAGE_UNLOADED }),
})

class DirectoryAdd extends React.Component {
    constructor() {
        super()
        this.state = {
            name: '',
            parent: null,
        }
        this.updateState = field => ev => {
            const state = this.state
            const newState = Object.assign({}, state, { [field]: ev.target.value })
            this.setState(newState)
        }
        this.submitForm = () => ev => {
            ev.preventDefault()
            const name = this.state.name
            const parent = this.state.parent
            const payload = agent.Files.createDirectory(name, parent)
            this.props.onSubmit(payload, parent)
        }
    }

    componentWillMount() {
        if (this.props.currentUser) {
            let search = this.props.location.search
            let directory = 'root'
            if (search) {
                let args = Util.getQueryStringArgs(search.toLowerCase())
                directory = args.parent ? args.parent : 'root'
                this.setState({ parent: directory })
            }
            let payload = agent.Files.getDirectorySimple(directory)
            this.props.onLoad(payload)
        } else {
            store.dispatch(push("/login"))
        }
    }
    componentWillReceiveProps(nextProps) {

    }
    componentWillUnmount() {
        this.props.onUnload()
    }

    render() {
        if (!this.props.directory) {
            return (
                <Loading currentUser={this.props.currentUser} />
            )
        }
        const name = this.state.name
        const directory = this.props.directory
        const parent_directory_path = Util.generateDirectoryPath(directory)
        return (
            <Translation>
                {
                    (t) => (
                        <div id="main">
                            <Nav selected={'files'} currentUser={this.props.currentUser} />
                            <div id="content">
                                <Header />
                                <div id="content-clear">
                                    <div className="focus-wrap">
                                        <div className='box-header'>
                                            <h2><Link to={`/files?directory=${directory.key}`}><i className="fad fa-chevron-square-left"></i></Link> {t('file.create_directory_title')}</h2>
                                        </div>
                                        <div className="form-item">
                                            <label>{t('file.label_parent_directory')}</label>
                                            <span><i className="fad fa-folder"></i> {parent_directory_path}</span>
                                        </div>
                                        <div className="form-item">
                                            <label>{t('file.label_name')}</label>
                                            <input type="text" placeholder="" value={name} onChange={this.updateState('name')} />
                                        </div>

                                        <div className="form-item">
                                            <button type="button" onClick={this.submitForm()} disabled={this.props.inProgress}>{this.props.inProgress ? t('file.create_button_progress') : t('file.create_button')} </button>
                                        </div>
                                        <ListErrors errors={this.props.errors} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
            </Translation>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DirectoryAdd)
